import BaseService from "../base-service/BaseService";

const ControllerBase: string = "product";

export default class ProductService {

  public static async GetProductsList(storeId: string) {
      let data: any = {};
  
      try {

        data = await BaseService.GetServices(ControllerBase, `${storeId}/list`);

      } catch (error) {
        console.log(error);
        throw error;
      }
  
      return data;
  }

  public static async GetProductsSyncPlatform(storeId: string) {
      let data: any = {};
  
      try {

        data = await BaseService.GetServices(ControllerBase, `${storeId}/search`);

      } catch (error) {
        console.log(error);
        throw error;
      }
  
      return data;
  }

  public static async GetProductSyncPlatform(storeId: string, platformCode: string) {
    let data: any = {};

    try {
      data = await BaseService.GetServices(ControllerBase, `${storeId}/search/${platformCode}`);

    } catch (error) {
      console.log(error);
      throw error;
    }

    return data;
  }

  public static async GetProductsFits(storeId: string) {
        let data: any = {};
    
        try {
    
          data = await BaseService.GetServices(ControllerBase, `${storeId}/fits`);

        } catch (error) {
          console.log(error);
          throw error;
        }
    
        return data;
  }

  public static async PostSaveChange(storeId: string, products: any[]) {
    let data: any = {};
  
    try {

      const params = {
        Content: products
      };
  
      data = await BaseService.PostServices(ControllerBase, `${storeId}/list`, params);

    } catch (error) {
      console.log(error);
      throw error;
    }
  
    return data;
  }

}